export default __webpack_public_path__ + "static/media/light_rank3.6d8ede53.svg";